module.exports = __webpack_public_path__ + "static/assets/1e914a4ab216c7528c510d95690a7696.svg";